export const reprintPin = {
    hideDeliveryAddress: false,
    deliveryManagement: {
        enabled: false,
    },
};
